import { render, staticRenderFns } from "./GenericRadioOption.vue?vue&type=template&id=408d0ffe&"
import script from "./GenericRadioOption.vue?vue&type=script&lang=js&"
export * from "./GenericRadioOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports